import React, { useState } from 'react';
import CryptoJS from 'crypto-js';
import InputField from "./FormFields/InputField";
import SelectField from "./FormFields/SelectField";
import TextAreaField from "./FormFields/TextAreaField";
import CheckboxField from "./FormFields/CheckboxField";
import {getFieldId, getHeader} from "../../lib";
import NameField from "./FormFields/NameField";

const Form = ({forms}) => {
  const contactForm = forms.find(form => form.title === 'Contact');

  const [formState, setFormState] = useState({
    apiURL: `${process.env.GATSBY_SITE_URL}/wp-json/gf/v2/forms/1/submissions`,
    formFields: contactForm?.formFields.nodes,
    submitButton: contactForm?.submitButton,
    successMessage: contactForm?.confirmations[0]?.message,
    "g-recaptcha-response": '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [formStatus, setFormStatus] = useState(null)

  const handleInputChange = (e) => {
    const {name, value} = e.target;
    setFormState(prevState => ({
      ...prevState,
      formFields: prevState.formFields.map(field =>
        field.label?.toLowerCase() === name.toLowerCase()
          ? {...field, value}
          : field
      ),
    }));
  }

  const handleCheckboxChange = (e) => {
    const newValue = e.target.checked ? "Yes" : "";
    handleInputChange({
      target: {
        name: e.target.name,
        value: newValue
      }
    });
  }

  function getInputName(formId, version) {
    const hash = CryptoJS.MD5('recaptchav3' + version + formId).toString();
    return 'input_' + hash;
  }

  const handleFormSubmit = async (token) => {
    setIsSubmitting(true);

    const data = formState.formFields.reduce((acc, field) => {
      const fieldId = getFieldId(field);
      acc[fieldId] = field.value;
      return acc;
    }, {});

    const formId = contactForm?.databaseId.toString() || '1';

    data[getInputName(formId, '1.1')] = token;
    try {
      const response = await fetch(formState.apiURL, {
        method: 'POST',
        headers: getHeader(),
        body: JSON.stringify(data),
      });

      if (response.status === 201 || response.status === 200) {
        setFormStatus(response.status);
      } else {
        setFormStatus(500);
      }
    } catch (error) {
      console.error("Somthing went wrong");
    } finally {
      resetForm();
      setIsSubmitting(false);
    }
  }

  const resetForm = () => {
    setFormState(prevState => ({
      ...prevState,
      formFields: prevState.formFields.map(field => ({...field, value: ''})),
    }));
  }

  const handleFormSubmitWithPreventDefault = async (e) => {
    e.preventDefault();
    if (typeof window === 'undefined') return;
    /* global grecaptcha */
    grecaptcha && grecaptcha?.ready(async function () {
      grecaptcha?.execute('6LdlpT0mAAAAAJyzu9m594sqZ0hXAs_OnUuvgQ2b', {action: 'submit'}).then(async function (token) {
        await handleFormSubmit(token);
      });
    });
  };

  return (
    <>
      <div className="form-container">
        {formStatus === 500 && (
          <div className="response" style={{margin: "1rem", color: "red", background: "white"}}>
            <p style={{padding: "1.5rem", color: "red"}}>
              We were unable to process your request. Please call or email using the
              information on this page.
            </p>
          </div>
        )}
        {(formStatus === 201 || formStatus === 200) ? (
          <div className="response">
            <p>Thanks for contacting us! We will get in touch with you shortly.</p>
          </div>
        ) : (
          <form
            name="contact-form"
            data-netlify="true"
            method="post"
            action={formState.apiURL}
            onSubmit={handleFormSubmitWithPreventDefault}
          >
            <input type="hidden" name="form-name" value="contact-form"/>
            {formState.formFields && formState.formFields.map(field =>
              <FormField field={field} key={field.databaseId + field.label} onInputChange={handleInputChange}
                         handleCheckboxChange={handleCheckboxChange}/>
            )}
            <div className="button-row">
              <div className="centered-container">
                <p className="text-recaptcha">
                  This site is protected by reCAPTCHA and the Google <a
                  target="_blank" rel="noreferrer"
                  href="https://policies.google.com/privacy">Privacy
                  Policy</a> and <a target="_blank" rel="noreferrer"
                                    href="https://policies.google.com/terms">Terms of Service</a> apply.</p>
                <button
                  type="submit" className="btn g-recaptcha" disabled={isSubmitting}>
                  {formState?.submitButton?.text}
                </button>
              </div>

            </div>
          </form>
        )}
      </div>
    </>
  );
}

const FormField = ({field, onInputChange, handleCheckboxChange}) => {
  const {type} = field;

  switch (type.toLowerCase()) {
    case 'text':
    case 'email':
    case 'phone':
      return <InputField field={field} onInputChange={onInputChange}/>;
    case 'name':
      return <NameField field={field} />;
    case 'select':
      return <SelectField field={field} onInputChange={onInputChange}/>;
    case 'textarea':
      return <TextAreaField field={field} onInputChange={onInputChange}/>;
    case 'checkbox':
      return <CheckboxField field={field} onInputChange={handleCheckboxChange}/>;
    default:
      return null;
  }
}


export default Form;


